import { forwardRef } from 'react';
import { Assert } from '@team/assert';
import { clsx } from '@team/clsx';
import { Tappable } from '../../services/tappable';
import { Loader } from '../../feedback/loader';
import { Props } from './types';
import { Mode, Size } from './enums';
import {
  activeModePresets,
  detectComponent,
  hoverModePresets,
  modePresets,
  sizePresets,
} from './model';
import css from './style.module.css';

export const Layout = forwardRef<HTMLElement, Props>(function Component(
  {
    mode = Mode.BEZELED,
    size = Size.SMALL,
    isLoading = false,
    onClick,
    children,
    ...props
  },
  forwardedRef
) {
  if (import.meta.env.DEV) {
    /**
     * 💬 Комопнент явно должен получать один из aria-атрибутов:
     * – aria-label
     * – aria-labelledby
     *
     * @todo расширить проверку на наличие `<VisualHidden />` в {@link children}
     * @todo декларировать логику в хелпер
     */
    if (
      [props['aria-label'], props['aria-labelledby']].every(Assert.isUndefined)
    ) {
      console.warn(
        '[TelegramUi.Button]: a11y police. Отсутствует один из пропсов: `aria-label` или `aria-labelledby`'
      );
    }
  }

  return (
    <Tappable
      {...props}
      Component={detectComponent(props)}
      baseClassName={clsx(css.root, modePresets[mode], sizePresets[size], {
        [css.loading]: isLoading,
      })}
      hoverMode={hoverModePresets[mode]}
      activeMode={activeModePresets[mode]}
      onClick={isLoading ? undefined : onClick}
      ref={forwardedRef}
    >
      {isLoading && <Loader className={css.loader} size="s" />}

      <span className={css.inner}>{children}</span>
    </Tappable>
  );
});
